<div class="modal-header">
  <h4 class="modal-title">Промяна на адрес по подразбиране</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <span class="form-label">Област*</span>
      <ng-select
        [items]="regions"
        bindValue="regionId"
        bindLabel="regionName"
        formControlName="regionId"
        notFoundText="Няма намерени области"
        placeholder="Изберете област"
        (change)="onChangeRegionId($event)"
        [class.is-valid]="regionId?.touched && regionId?.valid"
        [class.is-invalid]="regionId?.touched && regionId?.invalid">
      </ng-select>
      @if (regionId?.touched && regionId?.invalid) {
        <p class="m-0 invalid-feedback">Задължително поле!</p>
      }
    </fieldset>
    <fieldset class="mb-4">
      <span class="form-label">Община*</span>
      <ng-select
        [items]="municipalities"
        bindValue="municipalityId"
        bindLabel="municipalityName"
        formControlName="municipalityId"
        notFoundText="Няма намерени общини"
        placeholder="Изберете община"
        (change)="onChangeMunicipalityId($event)"
        [class.is-valid]="municipalityId?.touched && municipalityId?.valid"
        [class.is-invalid]="municipalityId?.touched && municipalityId?.invalid">
      </ng-select>
      @if (municipalityId?.touched && municipalityId?.invalid) {
        <p class="m-0 invalid-feedback">Задължително поле!</p>
      }
    </fieldset>
    <fieldset class="mb-4">
      <span class="form-label">Населено място*</span>
      <ng-select
        [items]="populatedPlaces"
        bindValue="populatedPlaceId"
        bindLabel="populatedPlaceName"
        formControlName="populatedPlaceId"
        notFoundText="Няма намерени населени мяста"
        placeholder="Изберете населено място"
        [class.is-valid]="populatedPlaceId?.touched && populatedPlaceId?.valid"
        [class.is-invalid]="populatedPlaceId?.touched && populatedPlaceId?.invalid">
      </ng-select>
      @if (populatedPlaceId?.touched && populatedPlaceId?.invalid) {
        <p class="m-0 invalid-feedback">Задължително поле!</p>
      }
    </fieldset>
  </form>
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
